import useLocalRoute from './LocalRouteHook';

export default useLocalRoute;